<div *ngFor="let item of editableDoc | keyvalue"><input type="checkbox" [checked]="selected === item.value " disabled> &nbsp; {{item.key}}</div>